// @ts-nocheck

/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  UpdateCurrentUserUsersMePatchMutationRequest,
  UpdateCurrentUserUsersMePatchMutationResponse,
  UpdateCurrentUserUsersMePatch422,
} from "../models/usersController/UpdateCurrentUserUsersMePatch.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@kubb/plugin-client/clients/axios";
import type { MutationObserverOptions, QueryClient } from "@tanstack/vue-query";
import type { MaybeRefOrGetter } from "vue";
import { updateCurrentUserUsersMePatch } from "../client/updateCurrentUserUsersMePatch.ts";
import { useMutation } from "@tanstack/vue-query";

export const updateCurrentUserUsersMePatchMutationKey = () =>
  [{ url: "/users/me" }] as const;

export type UpdateCurrentUserUsersMePatchMutationKey = ReturnType<
  typeof updateCurrentUserUsersMePatchMutationKey
>;

/**
 * @description Update current authenticated user profile.
 * @summary Update Current User
 * {@link /users/me}
 */
export function useUpdateCurrentUserUsersMePatch<TContext>(
  options: {
    mutation?: MutationObserverOptions<
      UpdateCurrentUserUsersMePatchMutationResponse,
      ResponseErrorConfig<UpdateCurrentUserUsersMePatch422>,
      { data: MaybeRefOrGetter<UpdateCurrentUserUsersMePatchMutationRequest> },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<UpdateCurrentUserUsersMePatchMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions?.mutationKey ?? updateCurrentUserUsersMePatchMutationKey();

  return useMutation<
    UpdateCurrentUserUsersMePatchMutationResponse,
    ResponseErrorConfig<UpdateCurrentUserUsersMePatch422>,
    { data: UpdateCurrentUserUsersMePatchMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return updateCurrentUserUsersMePatch(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
